// libraries
import { newNationOptions } from 'constants/selectOptions';
import { YnType } from 'enums';
import { atom } from 'recoil';
import { UserInfo } from '../models/auth.model';

const initialState = {
  // 회원가입 폼
  SignUpForm: {
    user: {
      username: '',
      fullName: '',
      password: '',
      mobile: '',
      nationId: '',
      mobileNationId: newNationOptions[0].value
    },
    userDetail: {
      gender: '',
      icNo: '',
      companyId: '',
      designationId: '',
      religionId: '',
      raceId: '',
      visaNo: '',
      visaExpiryDate: '',
      passportNo: '',
      passportExpiryDate: '',
      agreement: YnType.N,
      cidbNo: '',
      cidbExpiryDate: '',
      dateOfBirth: null,
      frsId: '',
      email: '',
      directIndirect: '',
      yearsOfExperience: '',
      psacNo: ''
    }
  }
};

/** 회원가입 폼 */
export const SignUpFormAtom = atom<UserInfo>({
  key: 'SignUpFormAtom',
  default: initialState.SignUpForm
});

/** 패스워드 확인 */
export const PasswordCheckAtom = atom<string>({
  key: 'PasswordCheckAtom',
  default: ''
});
